// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { 
//     FaSearch, FaSync, FaEye, FaDownload, FaUser, FaBriefcase, FaBuilding, FaCalendarAlt, FaCheck, FaTimes, FaSpinner, FaFilter
// } from 'react-icons/fa';
// import { FiBriefcase, FiSearch, FiClipboard } from 'react-icons/fi';
// import { toast } from 'react-toastify';

// import { API_BASE_URL, API_DOMAIN } from '../utils/config';

// const StatusBadge = ({ status, className = "" }) => {
//   const badges = {
//     signed: "bg-emerald-50 text-emerald-700 border-emerald-100 shadow-sm",
//     pending: "bg-amber-50 text-amber-700 border-amber-100 shadow-sm",
//     missing: "bg-gray-50 text-gray-400 border-gray-100 shadow-sm"
//   };

//   return (
//     <span className={`inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border transition-all duration-300 ${badges[status] || badges.missing} ${className}`}>
//       {status === 'signed' && <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-1.5 shadow-[0_0_8px_rgba(16,185,129,0.5)]"></div>}
//       {status === 'pending' && <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mr-1.5 shadow-[0_0_8px_rgba(245,158,11,0.5)]"></div>}
//       {status === 'missing' && <div className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-1.5"></div>}
//       {status}
//     </span>
//   );
// };

// const AcceptanceLetter = () => {
//     const [applications, setApplications] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [roleFilter, setRoleFilter] = useState("");
//     const [deptFilter, setDeptFilter] = useState("");
//     const [dateFilter, setDateFilter] = useState("");
    
//     const [selectedDoc, setSelectedDoc] = useState(null);
//     const [isViewerOpen, setIsViewerOpen] = useState(false);
    
//     // Global filter states
//     const [roles, setRoles] = useState([]);
//     const [departments, setDepartments] = useState([]);
//     const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//     const [roleSearchQuery, setRoleSearchQuery] = useState("");
//     const roleDropdownRef = useRef(null);

//     const [isDeptDropdownOpen, setIsDeptDropdownOpen] = useState(false);
//     const [deptSearchQuery, setDeptSearchQuery] = useState("");
//     const deptDropdownRef = useRef(null);

//     useEffect(() => {
//         fetchApplications();
//         fetchRoles();
//         fetchDepartments();

//         const handleClickOutside = (event) => {
//             if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//                 setIsRoleDropdownOpen(false);
//             }
//             if (deptDropdownRef.current && !deptDropdownRef.current.contains(event.target)) {
//                 setIsDeptDropdownOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const fetchRoles = async () => {
//         try {
//             const res = await axios.get(`${API_BASE_URL}/roles/all`);
//             if (res.data.success) {
//                 setRoles(res.data.data);
//             }
//         } catch (err) {
//             console.error("Failed to fetch roles:", err);
//         }
//     };

//     const fetchDepartments = async () => {
//         try {
//             const res = await axios.get(`${API_BASE_URL}/employees/get-employees`);
//             if (Array.isArray(res.data)) {
//                 const uniqueDepartments = [...new Set(res.data.map(emp => emp.department).filter(Boolean))];
//                 setDepartments(uniqueDepartments.sort());
//             } else if (res.data.employees) {
//                 const uniqueDepartments = [...new Set(res.data.employees.map(emp => emp.department).filter(Boolean))];
//                 setDepartments(uniqueDepartments.sort());
//             }
//         } catch (err) {
//             console.error("Failed to fetch departments:", err);
//         }
//     };

//     const fetchApplications = async () => {
//         try {
//             setLoading(true);
//             const res = await axios.get(`${API_BASE_URL}/applications/documents`);
//             if (res.data.success) {
//                 setApplications(res.data.data);
//             }
//         } catch (error) {
//             console.error("Error fetching documents:", error);
//             toast.error("Failed to load documents");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatDocUrl = (path) => {
//         if (!path) return "";
//         const cleanPath = path.replace(/\\/g, "/");
//         return `${API_DOMAIN}/${cleanPath}`;
//     };

//     function getSignedDocs(app) {
//         const docs = [];
//         if (app.candidateAgreementsUpload && String(app.candidateAgreementsUpload).trim().length > 0) {
//             docs.push({ type: "Agreement (Legacy)", path: app.candidateAgreementsUpload, date: app.updatedAt, id: `${app._id}-legacy` });
//         }
//         if (app.documentHistory) {
//             app.documentHistory.forEach((hist, idx) => {
//                 if (hist.signedPath && String(hist.signedPath).trim().length > 0) {
//                     docs.push({ type: hist.documentType || "Document", path: hist.signedPath, date: hist.signedAt || hist.sentAt, id: `${app._id}-hist-${idx}` });
//                 }
//             });
//         }
//         return docs;
//     }

//     const filteredApps = applications.filter(app => {
//         const query = searchTerm.toLowerCase();
//         const candidateName = `${app.firstName} ${app.lastName}`.toLowerCase();
//         const candEmail = (app.candidateId?.email || "").toLowerCase();
//         const role = (app.jobId?.role || "").toLowerCase();
//         const dept = (app.jobId?.department || "").toLowerCase();
        
//         const hasSignedDocs = getSignedDocs(app).length > 0;
//         const isProcessActive = app.offerSentAt || (app.documentHistory && app.documentHistory.length > 0);
        
//         const matchesSearch = candidateName.includes(query) || role.includes(query) || candEmail.includes(query);
//         const matchesRole = roleFilter ? role === roleFilter.toLowerCase() : true;
//         const matchesDept = deptFilter ? dept === deptFilter.toLowerCase() : true;
//         const matchesDate = dateFilter ? new Date(app.updatedAt).toISOString().slice(0, 10) === dateFilter : true;

//         return (hasSignedDocs || isProcessActive) && matchesSearch && matchesRole && matchesDept && matchesDate;
//     });

//     // Clear local derived lists since we use global lists now

//     if (loading) return (
//         <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
//             <div className="text-center">
//                 <FaSpinner className="w-10 h-10 text-blue-600 animate-spin mx-auto mb-4" />
//                 <p className="text-sm font-bold text-gray-400 uppercase tracking-widest">Loading Vault...</p>
//             </div>
//         </div>
//     );

//     return (
//         <div className="w-full min-h-screen p-0 md:p-2 lg:p-4 pb-20 bg-[#F8FAFC]">
//             {/* Header / Filters Section */}
//             <div className="p-3 mb-3 bg-white rounded-lg shadow-md">
//                 <div className="flex flex-wrap items-center gap-2">
//                     <div className="relative flex-1 min-w-[180px]">
//                         <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
//                         <input
//                             type="text"
//                             placeholder="Search name, role..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent outline-none"
//                         />
//                     </div>
//                     {/* Role Filter - Searchable Dropdown */}
//                     <div className="relative" ref={roleDropdownRef}>
//                         <button
//                             onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//                             className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
//                                 roleFilter 
//                                     ? 'bg-blue-600 text-white hover:bg-blue-700' 
//                                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                             }`}
//                         >
//                             <FiBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
//                         </button>
                        
//                         {isRoleDropdownOpen && (
//                             <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//                                 <div className="p-2 border-b border-gray-100 bg-gray-50">
//                                     <div className="relative">
//                                         <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                                         <input
//                                             type="text"
//                                             className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                                             placeholder="Search roles..."
//                                             value={roleSearchQuery}
//                                             onChange={(e) => setRoleSearchQuery(e.target.value)}
//                                             onClick={(e) => e.stopPropagation()}
//                                             autoFocus
//                                         />
//                                     </div>
//                                 </div>
//                                 <div 
//                                     onClick={() => {
//                                         setRoleFilter('');
//                                         setIsRoleDropdownOpen(false);
//                                         setRoleSearchQuery('');
//                                     }}
//                                     className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
//                                         !roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
//                                     }`}
//                                 >
//                                     All Roles
//                                 </div>
//                                 {roles
//                                     .filter(r => (r.name || "").toLowerCase().includes(roleSearchQuery.toLowerCase()))
//                                     .map((r) => (
//                                         <div 
//                                             key={r._id}
//                                             onClick={() => {
//                                                 setRoleFilter(r.name);
//                                                 setIsRoleDropdownOpen(false);
//                                                 setRoleSearchQuery('');
//                                             }}
//                                             className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
//                                                 roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
//                                             }`}
//                                         >
//                                             {r.name}
//                                         </div>
//                                     ))}
//                                 {roles.filter(r => (r.name || "").toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
//                                     <div className="px-3 py-2 text-xs text-gray-400 text-center">
//                                         No roles found
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     {/* Department Filter - Searchable Dropdown */}
//                     <div className="relative" ref={deptDropdownRef}>
//                         <button
//                             onClick={() => setIsDeptDropdownOpen(!isDeptDropdownOpen)}
//                             className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
//                                 deptFilter 
//                                     ? 'bg-blue-600 text-white hover:bg-blue-700' 
//                                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                             }`}
//                         >
//                             <FiClipboard className="text-xs" /> Dept {deptFilter && `: ${deptFilter}`}
//                         </button>
                        
//                         {isDeptDropdownOpen && (
//                             <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//                                 <div className="p-2 border-b border-gray-100 bg-gray-50">
//                                     <div className="relative">
//                                         <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                                         <input
//                                             type="text"
//                                             className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                                             placeholder="Search departments..."
//                                             value={deptSearchQuery}
//                                             onChange={(e) => setDeptSearchQuery(e.target.value)}
//                                             onClick={(e) => e.stopPropagation()}
//                                             autoFocus
//                                         />
//                                     </div>
//                                 </div>
//                                 <div 
//                                     onClick={() => {
//                                         setDeptFilter('');
//                                         setIsDeptDropdownOpen(false);
//                                         setDeptSearchQuery('');
//                                     }}
//                                     className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
//                                         !deptFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
//                                     }`}
//                                 >
//                                     All Depts
//                                 </div>
//                                 {departments
//                                     .filter(d => (d || "").toLowerCase().includes(deptSearchQuery.toLowerCase()))
//                                     .map((dept, idx) => (
//                                         <div 
//                                             key={idx}
//                                             onClick={() => {
//                                                 setDeptFilter(dept);
//                                                 setIsDeptDropdownOpen(false);
//                                                 setDeptSearchQuery('');
//                                             }}
//                                             className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
//                                                 deptFilter === dept ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
//                                             }`}
//                                         >
//                                             {dept}
//                                         </div>
//                                     ))}
//                                 {departments.filter(d => (d || "").toLowerCase().includes(deptSearchQuery.toLowerCase())).length === 0 && (
//                                     <div className="px-3 py-2 text-xs text-gray-400 text-center">
//                                         No departments found
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     {/* Date Filter */}
//                     <div className="relative w-[130px]">
//                         <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-400 font-bold uppercase pointer-events-none">Date:</span>
//                         <input
//                             type="date"
//                             value={dateFilter}
//                             onChange={(e) => setDateFilter(e.target.value)}
//                             className="w-full pl-12 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500"
//                         />
//                     </div>

//                     <button 
//                         onClick={fetchApplications} 
//                         className="w-8 h-8 rounded-md bg-white border border-gray-300 text-gray-500 hover:bg-blue-50 hover:text-blue-600 transition-all flex items-center justify-center shadow-sm"
//                     >
//                         <FaSync size={12} className={loading ? 'animate-spin' : ''} />
//                     </button>
//                     {(searchTerm || roleFilter || deptFilter || dateFilter) && (
//                         <button 
//                             onClick={() => { 
//                                 setSearchTerm(""); 
//                                 setRoleFilter(""); 
//                                 setDeptFilter(""); 
//                                 setDateFilter(""); 
//                                 setRoleSearchQuery("");
//                                 setDeptSearchQuery("");
//                             }}
//                             className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
//                         >
//                             Clear
//                         </button>
//                     )}
//                 </div>
//             </div>

//             {/* Table Section */}
//             <div className="overflow-x-auto bg-white shadow-xl rounded-2xl border border-gray-100">
//                 <table className="min-w-full border-collapse">
//                     <thead className="text-sm text-left text-white bg-gradient-to-r from-green-500 to-blue-600">
//                         <tr>
//                             <th className="px-6 py-3 text-center font-bold">Candidate Details</th>
//                             <th className="px-4 py-3 text-center font-bold">Role</th>
//                             <th className="px-6 py-3 text-center font-bold">Offer Letter</th>
//                             <th className="px-6 py-3 text-center font-bold">Signed Agreements</th>
//                             <th className="px-4 py-3 text-center font-bold">Status</th>
//                             <th className="px-4 py-3 text-center font-bold">Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody className="divide-y divide-gray-100">
//                         {filteredApps.map((app) => {
//                             const docs = getSignedDocs(app);
//                             const offerDoc = docs.find(d => d.type === "Offer" || d.type === "Offer Letter");
//                             // Strictly show only agreements in this column
//                             const agreementDocs = docs.filter(d => d.type.toLowerCase().includes("agreement"));
                            
//                             const candName = `${app.firstName} ${app.lastName}`;
//                             const candEmail = app.candidateId?.email || "No email";
                            
//                             return (
//                                 <tr key={app._id} className="border-b hover:bg-gray-50 transition-colors">
//                                     <td className="px-4 py-3 text-center font-medium">
//                                         <div className="text-gray-900 whitespace-nowrap text-sm">{candName}</div>
//                                         <div className="text-[10px] text-gray-600">{new Date(app.updatedAt).toLocaleDateString()}</div>
//                                     </td>
//                                     <td className="px-4 py-3 text-center">
//                                         <span className="inline-block px-2 py-1 bg-blue-50 text-blue-600 text-[10px] rounded-full border border-blue-100 font-bold uppercase tracking-tight">
//                                             {app.jobId?.role || "N/A"}
//                                         </span>
//                                     </td>
                                    
//                                     {/* Offer Letter Column */}
//                                     <td className="px-4 py-3 text-center border-r border-gray-50">
//                                         {offerDoc ? (
//                                             <div className="inline-flex items-center gap-2 bg-blue-50/50 px-3 py-1.5 rounded-xl border border-blue-100">
//                                                 <div className="flex flex-col items-center">
//                                                     <span className="text-[10px] font-bold text-blue-700 uppercase tracking-tight">Offer Signed</span>
//                                                     <span className="text-[8px] font-medium text-blue-400 uppercase">{new Date(offerDoc.date).toLocaleDateString()}</span>
//                                                 </div>
//                                                 <div className="flex items-center gap-1 border-l border-blue-200 pl-2">
//                                                     <button onClick={() => { setSelectedDoc(offerDoc); setIsViewerOpen(true); }} className="p-1 text-blue-600 hover:bg-blue-100 rounded-md transition-all"><FaEye size={12}/></button>
//                                                     <button onClick={() => window.open(formatDocUrl(offerDoc.path), "_blank")} className="p-1 text-emerald-600 hover:bg-emerald-100 rounded-md transition-all"><FaDownload size={12}/></button>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             <span className="text-[10px] font-medium text-gray-300 uppercase italic">Not Signed</span>
//                                         )}
//                                     </td>

//                                     {/* Agreements Column */}
//                                     <td className="px-4 py-3 text-left border-r border-gray-50">
//                                         <div className="flex flex-col gap-1.5 min-w-[180px]">
//                                             {agreementDocs.length > 0 ? agreementDocs.map((doc, idx) => (
//                                                 <div key={doc.id} className="flex items-center justify-between bg-emerald-50/30 p-1.5 rounded-lg border border-emerald-100/50">
//                                                     <div className="flex flex-col">
//                                                         <span className="text-[10px] font-bold text-indigo-600 uppercase tracking-tight">
//                                                             {doc.type}
//                                                         </span>
//                                                         <span className="text-[8px] font-medium text-emerald-500 uppercase">{new Date(doc.date).toLocaleDateString()}</span>
//                                                     </div>
//                                                     <div className="flex items-center gap-1">
//                                                         <button onClick={() => { setSelectedDoc(doc); setIsViewerOpen(true); }} className="p-1 text-blue-600 hover:bg-blue-50 rounded-md"><FaEye size={12}/></button>
//                                                         <button onClick={() => window.open(formatDocUrl(doc.path), "_blank")} className="p-1 text-emerald-600 hover:bg-emerald-50 rounded-md"><FaDownload size={12}/></button>
//                                                     </div>
//                                                 </div>
//                                             )) : (
//                                                 <span className="text-[10px] font-medium text-gray-300 uppercase italic text-center w-full block">No Agreements</span>
//                                             )}
//                                         </div>
//                                     </td>

//                                     <td className="px-4 py-3 text-center">
//                                         <StatusBadge 
//                                             status={
//                                                 offerDoc && agreementDocs.length > 0 ? "signed" : 
//                                                 (offerDoc || agreementDocs.length > 0) ? "pending" : "missing"
//                                             } 
//                                         />
//                                     </td>

//                                     <td className="px-4 py-3 text-center">
//                                         <div className="flex justify-center gap-2">
//                                             {docs.length > 0 ? (
//                                                 <>
//                                                     <button
//                                                         onClick={() => { setSelectedDoc(docs[0]); setIsViewerOpen(true); }}
//                                                         className="px-3 py-1 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-lg transition-all border border-indigo-100 flex items-center gap-1.5 text-[10px] font-bold"
//                                                     >
//                                                         <FaEye /> View
//                                                     </button>
//                                                     <button
//                                                         onClick={() => window.open(formatDocUrl(docs[0].path), "_blank")}
//                                                         className="px-3 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all flex items-center gap-1.5 text-[10px] font-bold shadow-sm"
//                                                     >
//                                                         <FaDownload /> Save
//                                                     </button>
//                                                 </>
//                                             ) : (
//                                                 <span className="text-[10px] text-gray-400 italic">No Actions</span>
//                                             )}
//                                         </div>
//                                     </td>
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>
//                 {filteredApps.length === 0 && (
//                     <div className="p-12 text-center">
//                         <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-300">
//                             <FaBriefcase size={24} />
//                         </div>
//                         <p className="text-gray-400 font-bold uppercase tracking-widest text-xs">No active records found</p>
//                     </div>
//                 )}
//             </div>

//             {/* Document Viewer Modal */}
//             {isViewerOpen && selectedDoc && (
//                 <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
//                     <div className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity" onClick={() => setIsViewerOpen(false)}></div>
//                     <div className="relative bg-white w-full h-full max-w-5xl rounded-xl shadow-2xl overflow-hidden flex flex-col border border-gray-200">
//                         {/* Modal Header */}
//                         <div className="px-6 py-4 bg-white border-b border-gray-200 flex items-center justify-between shrink-0">
//                             <div className="flex items-center gap-4">
//                                 <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center shadow-sm">
//                                     <FaBriefcase size={18} />
//                                 </div>
//                                 <div>
//                                     <h2 className="text-lg font-semibold text-gray-800 tracking-tight uppercase">{selectedDoc.type}</h2>
//                                     <p className="text-blue-600 text-[10px] font-bold uppercase tracking-wider mt-0.5">Administration Vault • Signed {new Date(selectedDoc.date).toLocaleDateString()}</p>
//                                 </div>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <button 
//                                     onClick={() => window.open(formatDocUrl(selectedDoc.path), "_blank")}
//                                     className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-xs font-bold uppercase tracking-wider hover:bg-blue-700 transition-all shadow-md"
//                                 >
//                                     <FaDownload /> Download
//                                 </button>
//                                 <button onClick={() => setIsViewerOpen(false)} className="p-2 text-gray-400 hover:text-red-500 rounded-lg transition-all">
//                                     <FaTimes size={18} />
//                                 </button>
//                             </div>
//                         </div>

//                         {/* Modal Body */}
//                         <div className="flex-1 bg-gray-50 p-4 overflow-hidden relative">
//                             <iframe src={formatDocUrl(selectedDoc.path)} className="w-full h-full border border-gray-200 rounded-lg shadow-inner bg-white" title="Document Viewer" />
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AcceptanceLetter;


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { 
    FaSearch, FaSync, FaEye, FaDownload, FaUser, FaBriefcase, FaBuilding, FaCalendarAlt, FaCheck, FaTimes, FaSpinner, FaFilter
} from 'react-icons/fa';
import { FiBriefcase, FiSearch, FiClipboard } from 'react-icons/fi';
import { toast } from 'react-toastify';

const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';
const API_DOMAIN = 'https://ingrainhirebackend.ingrainsystems.com';

const StatusBadge = ({ status, className = "" }) => {
  const badges = {
    signed: "bg-emerald-50 text-emerald-700 border-emerald-100 shadow-sm",
    pending: "bg-amber-50 text-amber-700 border-amber-100 shadow-sm",
    missing: "bg-gray-50 text-gray-400 border-gray-100 shadow-sm"
  };

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border transition-all duration-300 ${badges[status] || badges.missing} ${className}`}>
      {status === 'signed' && <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-1.5 shadow-[0_0_8px_rgba(16,185,129,0.5)]"></div>}
      {status === 'pending' && <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mr-1.5 shadow-[0_0_8px_rgba(245,158,11,0.5)]"></div>}
      {status === 'missing' && <div className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-1.5"></div>}
      {status}
    </span>
  );
};

const AcceptanceLetter = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [roleFilter, setRoleFilter] = useState("");
    const [deptFilter, setDeptFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    
    // Global filter states
    const [roles, setRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const [roleSearchQuery, setRoleSearchQuery] = useState("");
    const roleDropdownRef = useRef(null);

    const [isDeptDropdownOpen, setIsDeptDropdownOpen] = useState(false);
    const [deptSearchQuery, setDeptSearchQuery] = useState("");
    const deptDropdownRef = useRef(null);

    // Get clientId from localStorage
    const getClientId = () => {
        return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
    };

    useEffect(() => {
        fetchApplications();
        fetchRoles();
        fetchDepartments();

        const handleClickOutside = (event) => {
            if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
                setIsRoleDropdownOpen(false);
            }
            if (deptDropdownRef.current && !deptDropdownRef.current.contains(event.target)) {
                setIsDeptDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchRoles = async () => {
        try {
            const clientId = getClientId();
            const res = await axios.get(`${API_BASE_URL}/roles/all?clientId=${clientId}`);
            if (res.data.success) {
                setRoles(res.data.data);
            }
        } catch (err) {
            console.error("Failed to fetch roles:", err);
        }
    };

    const fetchDepartments = async () => {
        try {
            const clientId = getClientId();
            const res = await axios.get(`${API_BASE_URL}/employees/get-employees/${clientId}`);
            if (Array.isArray(res.data)) {
                const uniqueDepartments = [...new Set(res.data.map(emp => emp.department).filter(Boolean))];
                setDepartments(uniqueDepartments.sort());
            } else if (res.data.employees) {
                const uniqueDepartments = [...new Set(res.data.employees.map(emp => emp.department).filter(Boolean))];
                setDepartments(uniqueDepartments.sort());
            } else if (res.data.data && Array.isArray(res.data.data)) {
                const uniqueDepartments = [...new Set(res.data.data.map(emp => emp.department).filter(Boolean))];
                setDepartments(uniqueDepartments.sort());
            }
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchApplications = async () => {
        try {
            setLoading(true);
            const clientId = getClientId();
            const res = await axios.get(`${API_BASE_URL}/applications/documents/${clientId}`);
            if (res.data.success) {
                setApplications(res.data.data || []);
            } else {
                setApplications([]);
            }
        } catch (error) {
            console.error("Error fetching documents:", error);
            toast.error("Failed to load documents");
            setApplications([]);
        } finally {
            setLoading(false);
        }
    };

    const formatDocUrl = (path) => {
        if (!path) return "";
        if (path.startsWith('http')) {
            return path;
        }
        const cleanPath = path.replace(/\\/g, "/");
        return `${API_DOMAIN}/${cleanPath}`;
    };

    function getSignedDocs(app) {
        const docs = [];
        if (app.candidateAgreementsUpload && String(app.candidateAgreementsUpload).trim().length > 0) {
            docs.push({ type: "Agreement (Legacy)", path: app.candidateAgreementsUpload, date: app.updatedAt, id: `${app._id}-legacy` });
        }
        if (app.documentHistory) {
            app.documentHistory.forEach((hist, idx) => {
                if (hist.signedPath && String(hist.signedPath).trim().length > 0) {
                    docs.push({ type: hist.documentType || "Document", path: hist.signedPath, date: hist.signedAt || hist.sentAt, id: `${app._id}-hist-${idx}` });
                }
            });
        }
        return docs;
    }

    const filteredApps = applications.filter(app => {
        const query = searchTerm.toLowerCase();
        const candidateName = `${app.firstName} ${app.lastName}`.toLowerCase();
        const candEmail = (app.candidateId?.email || "").toLowerCase();
        const role = (app.jobId?.role || "").toLowerCase();
        const dept = (app.jobId?.department || "").toLowerCase();
        
        const hasSignedDocs = getSignedDocs(app).length > 0;
        const isProcessActive = app.offerSentAt || (app.documentHistory && app.documentHistory.length > 0);
        
        const matchesSearch = candidateName.includes(query) || role.includes(query) || candEmail.includes(query);
        const matchesRole = roleFilter ? role === roleFilter.toLowerCase() : true;
        const matchesDept = deptFilter ? dept === deptFilter.toLowerCase() : true;
        const matchesDate = dateFilter ? new Date(app.updatedAt).toISOString().slice(0, 10) === dateFilter : true;

        return (hasSignedDocs || isProcessActive) && matchesSearch && matchesRole && matchesDept && matchesDate;
    });

    if (loading) return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
            <div className="text-center">
                <FaSpinner className="w-10 h-10 text-blue-600 animate-spin mx-auto mb-4" />
                <p className="text-sm font-bold text-gray-400 uppercase tracking-widest">Loading Vault...</p>
            </div>
        </div>
    );

    return (
        <div className="w-full min-h-screen p-0 md:p-2 lg:p-4 pb-20 bg-[#F8FAFC]">
            {/* Header / Filters Section */}
            <div className="p-3 mb-3 bg-white rounded-lg shadow-md">
                <div className="flex flex-wrap items-center gap-2">
                    <div className="relative flex-1 min-w-[180px]">
                        <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                        <input
                            type="text"
                            placeholder="Search name, role..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent outline-none"
                        />
                    </div>
                    
                    {/* Role Filter - Searchable Dropdown */}
                    <div className="relative" ref={roleDropdownRef}>
                        <button
                            onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
                            className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                                roleFilter 
                                    ? 'bg-blue-600 text-white hover:bg-blue-700' 
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                            }`}
                        >
                            <FiBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
                        </button>
                        
                        {isRoleDropdownOpen && (
                            <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                                <div className="p-2 border-b border-gray-100 bg-gray-50">
                                    <div className="relative">
                                        <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                        <input
                                            type="text"
                                            className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            placeholder="Search roles..."
                                            value={roleSearchQuery}
                                            onChange={(e) => setRoleSearchQuery(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                                <div 
                                    onClick={() => {
                                        setRoleFilter('');
                                        setIsRoleDropdownOpen(false);
                                        setRoleSearchQuery('');
                                    }}
                                    className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
                                        !roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                                    }`}
                                >
                                    All Roles
                                </div>
                                {roles
                                    .filter(r => (r.name || "").toLowerCase().includes(roleSearchQuery.toLowerCase()))
                                    .map((r) => (
                                        <div 
                                            key={r._id}
                                            onClick={() => {
                                                setRoleFilter(r.name);
                                                setIsRoleDropdownOpen(false);
                                                setRoleSearchQuery('');
                                            }}
                                            className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
                                                roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                                            }`}
                                        >
                                            {r.name}
                                        </div>
                                    ))}
                                {roles.filter(r => (r.name || "").toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
                                    <div className="px-3 py-2 text-xs text-gray-400 text-center">
                                        No roles found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Department Filter - Searchable Dropdown */}
                    <div className="relative" ref={deptDropdownRef}>
                        <button
                            onClick={() => setIsDeptDropdownOpen(!isDeptDropdownOpen)}
                            className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                                deptFilter 
                                    ? 'bg-blue-600 text-white hover:bg-blue-700' 
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                            }`}
                        >
                            <FiClipboard className="text-xs" /> Dept {deptFilter && `: ${deptFilter}`}
                        </button>
                        
                        {isDeptDropdownOpen && (
                            <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                                <div className="p-2 border-b border-gray-100 bg-gray-50">
                                    <div className="relative">
                                        <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                        <input
                                            type="text"
                                            className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            placeholder="Search departments..."
                                            value={deptSearchQuery}
                                            onChange={(e) => setDeptSearchQuery(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                                <div 
                                    onClick={() => {
                                        setDeptFilter('');
                                        setIsDeptDropdownOpen(false);
                                        setDeptSearchQuery('');
                                    }}
                                    className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
                                        !deptFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                                    }`}
                                >
                                    All Depts
                                </div>
                                {departments
                                    .filter(d => (d || "").toLowerCase().includes(deptSearchQuery.toLowerCase()))
                                    .map((dept, idx) => (
                                        <div 
                                            key={idx}
                                            onClick={() => {
                                                setDeptFilter(dept);
                                                setIsDeptDropdownOpen(false);
                                                setDeptSearchQuery('');
                                            }}
                                            className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
                                                deptFilter === dept ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                                            }`}
                                        >
                                            {dept}
                                        </div>
                                    ))}
                                {departments.filter(d => (d || "").toLowerCase().includes(deptSearchQuery.toLowerCase())).length === 0 && (
                                    <div className="px-3 py-2 text-xs text-gray-400 text-center">
                                        No departments found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Date Filter */}
                    <div className="relative w-[130px]">
                        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-400 font-bold uppercase pointer-events-none">Date:</span>
                        <input
                            type="date"
                            value={dateFilter}
                            onChange={(e) => setDateFilter(e.target.value)}
                            className="w-full pl-12 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500"
                        />
                    </div>

                    <button 
                        onClick={fetchApplications} 
                        className="w-8 h-8 rounded-md bg-white border border-gray-300 text-gray-500 hover:bg-blue-50 hover:text-blue-600 transition-all flex items-center justify-center shadow-sm"
                    >
                        <FaSync size={12} className={loading ? 'animate-spin' : ''} />
                    </button>
                    
                    {(searchTerm || roleFilter || deptFilter || dateFilter) && (
                        <button 
                            onClick={() => { 
                                setSearchTerm(""); 
                                setRoleFilter(""); 
                                setDeptFilter(""); 
                                setDateFilter(""); 
                                setRoleSearchQuery("");
                                setDeptSearchQuery("");
                            }}
                            className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
                        >
                            Clear
                        </button>
                    )}
                </div>
            </div>

            {/* Table Section */}
            <div className="overflow-x-auto bg-white shadow-xl rounded-2xl border border-gray-100">
                <table className="min-w-full border-collapse">
                    <thead className="text-sm text-left text-white bg-gradient-to-r from-green-500 to-blue-600">
                        <tr>
                            <th className="px-6 py-4 text-center font-bold text-xs uppercase tracking-wider">Candidate Details</th>
                            <th className="px-4 py-4 text-center font-bold text-xs uppercase tracking-wider">Role</th>
                            <th className="px-6 py-4 text-center font-bold text-xs uppercase tracking-wider">Offer Letter</th>
                            <th className="px-6 py-4 text-center font-bold text-xs uppercase tracking-wider">Signed Agreements</th>
                            <th className="px-4 py-4 text-center font-bold text-xs uppercase tracking-wider">Status</th>
                            <th className="px-4 py-4 text-center font-bold text-xs uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {filteredApps.map((app) => {
                            const docs = getSignedDocs(app);
                            const offerDoc = docs.find(d => d.type === "Offer" || d.type === "Offer Letter" || d.type.toLowerCase().includes("offer"));
                            const agreementDocs = docs.filter(d => d.type.toLowerCase().includes("agreement"));
                            
                            const candName = `${app.firstName} ${app.lastName}`;
                            const candEmail = app.candidateId?.email || "No email";
                            
                            return (
                                <tr key={app._id} className="border-b hover:bg-gray-50 transition-colors">
                                    <td className="px-4 py-3 text-center">
                                        <div className="text-gray-900 whitespace-nowrap font-bold text-sm">{candName}</div>
                                        <div className="text-[10px] text-gray-500 mt-0.5">{new Date(app.updatedAt).toLocaleDateString()}</div>
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        <span className="inline-block px-2 py-1 bg-blue-50 text-blue-600 text-[10px] rounded-full border border-blue-100 font-bold uppercase tracking-tight">
                                            {app.jobId?.role || "N/A"}
                                        </span>
                                    </td>
                                    
                                    {/* Offer Letter Column */}
                                    <td className="px-4 py-3 text-center">
                                        {offerDoc ? (
                                            <div className="inline-flex items-center gap-2 bg-blue-50/50 px-3 py-1.5 rounded-xl border border-blue-100">
                                                <div className="flex flex-col items-center">
                                                    <span className="text-[10px] font-bold text-blue-700 uppercase tracking-tight">Offer Signed</span>
                                                    <span className="text-[8px] font-medium text-blue-400 uppercase">{new Date(offerDoc.date).toLocaleDateString()}</span>
                                                </div>
                                                <div className="flex items-center gap-1 border-l border-blue-200 pl-2">
                                                    <button onClick={() => { setSelectedDoc(offerDoc); setIsViewerOpen(true); }} className="p-1.5 text-blue-600 hover:bg-blue-100 rounded-md transition-all">
                                                        <FaEye size={12}/>
                                                    </button>
                                                    <button onClick={() => window.open(formatDocUrl(offerDoc.path), "_blank")} className="p-1.5 text-emerald-600 hover:bg-emerald-100 rounded-md transition-all">
                                                        <FaDownload size={12}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <span className="text-[10px] font-medium text-gray-300 uppercase italic">Not Signed</span>
                                        )}
                                    </td>

                                    {/* Agreements Column */}
                                    <td className="px-4 py-3 text-left">
                                        <div className="flex flex-col gap-1.5 min-w-[180px]">
                                            {agreementDocs.length > 0 ? agreementDocs.map((doc, idx) => (
                                                <div key={doc.id} className="flex items-center justify-between bg-emerald-50/30 p-1.5 rounded-lg border border-emerald-100/50">
                                                    <div className="flex flex-col">
                                                        <span className="text-[10px] font-bold text-indigo-600 uppercase tracking-tight">
                                                            {doc.type}
                                                        </span>
                                                        <span className="text-[8px] font-medium text-emerald-500 uppercase">{new Date(doc.date).toLocaleDateString()}</span>
                                                    </div>
                                                    <div className="flex items-center gap-1">
                                                        <button onClick={() => { setSelectedDoc(doc); setIsViewerOpen(true); }} className="p-1 text-blue-600 hover:bg-blue-50 rounded-md">
                                                            <FaEye size={12}/>
                                                        </button>
                                                        <button onClick={() => window.open(formatDocUrl(doc.path), "_blank")} className="p-1 text-emerald-600 hover:bg-emerald-50 rounded-md">
                                                            <FaDownload size={12}/>
                                                        </button>
                                                    </div>
                                                </div>
                                            )) : (
                                                <span className="text-[10px] font-medium text-gray-300 uppercase italic text-center w-full block">No Agreements</span>
                                            )}
                                        </div>
                                    </td>

                                    <td className="px-4 py-3 text-center">
                                        <div className="flex justify-center">
                                            <StatusBadge status={docs.length > 0 ? "signed" : "pending"} />
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        <div className="flex justify-center gap-2">
                                            {docs.length > 0 && (
                                                <>
                                                    <button
                                                        onClick={() => { setSelectedDoc(docs[0]); setIsViewerOpen(true); }}
                                                        className="px-3 py-1.5 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm hover:shadow-md border border-indigo-100 flex items-center justify-center gap-1.5 text-[10px] font-bold"
                                                    >
                                                        <FaEye className="text-xs" /> View
                                                    </button>
                                                    <button
                                                        onClick={() => window.open(formatDocUrl(docs[0].path), "_blank")}
                                                        className="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg"
                                                    >
                                                        <FaDownload className="text-xs" /> Save
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {filteredApps.length === 0 && (
                    <div className="p-12 text-center">
                        <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-300">
                            <FaBriefcase size={24} />
                        </div>
                        <p className="text-gray-400 font-bold uppercase tracking-widest text-xs">No active records found</p>
                    </div>
                )}
            </div>

            {/* Document Viewer Modal */}
            {isViewerOpen && selectedDoc && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity" onClick={() => setIsViewerOpen(false)}></div>
                    <div className="relative bg-white w-full h-full max-w-5xl rounded-xl shadow-2xl overflow-hidden flex flex-col border border-gray-200">
                        {/* Modal Header */}
                        <div className="px-6 py-4 bg-white border-b border-gray-200 flex items-center justify-between shrink-0">
                            <div className="flex items-center gap-4">
                                <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center shadow-sm">
                                    <FaBriefcase size={18} />
                                </div>
                                <div>
                                    <h2 className="text-lg font-semibold text-gray-800 tracking-tight uppercase">{selectedDoc.type}</h2>
                                    <p className="text-blue-600 text-[10px] font-bold uppercase tracking-wider mt-0.5">Administration Vault • Signed {new Date(selectedDoc.date).toLocaleDateString()}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <button 
                                    onClick={() => window.open(formatDocUrl(selectedDoc.path), "_blank")}
                                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-xs font-bold uppercase tracking-wider hover:bg-blue-700 transition-all shadow-md"
                                >
                                    <FaDownload /> Download
                                </button>
                                <button onClick={() => setIsViewerOpen(false)} className="p-2 text-gray-400 hover:text-red-500 rounded-lg transition-all">
                                    <FaTimes size={18} />
                                </button>
                            </div>
                        </div>

                        {/* Modal Body */}
                        <div className="flex-1 bg-gray-50 p-4 overflow-hidden relative">
                            <iframe 
                                src={formatDocUrl(selectedDoc.path)} 
                                className="w-full h-full border border-gray-200 rounded-lg shadow-inner bg-white" 
                                title="Document Viewer" 
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AcceptanceLetter;